import React, {useContext, useEffect, useState} from 'react';
import moment from 'moment';
import _ from 'lodash';
import UserContext from '../../common/UserContext.js';

// css
import '../../../assets/css/EADashboard.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// kendo react
import {
    Chart,
    ChartTitle,
    ChartTooltip,
    ChartLegend,
    ChartCategoryAxisTitle,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxis,
    ChartValueAxisItem,
} from '@progress/kendo-react-charts';
import {formatNumber} from '@progress/kendo-intl';

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    yearKey,
    mainMessages, actualUseKey, predictedUseKey
} from '../../../assets/text/MultilingualText.js';

function BudgetUtilizationChart(props) {
    const {
        eA,
        pool,
        currency,
        chartColors,
        AXIS_LABELS,
        NoDataOverlay
    } = props;
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    const [totalCost, setTotalCost] = useState([]);

    // total cost tooltip
    const totalCostTooltip = ({point}) => {
        let data = point.dataItem;
        let cost = data.total_cost;
        let date = moment(data.date).format('ll');
        return <span>{date} {formatNumber(cost, {style: "currency"})}</span>
    }

    // create variable budget utilization chart data
    useEffect(() => {
        let subPool = pool.find(p => p.year === eA.year);
        let totals = [];
        if (subPool) {
            // create array of objects for every day from start to end date
            let start = new Date(subPool.start_date);
            let end = new Date(subPool.end_date);
            let current = start;
            while (current <= end) {
                totals.push({
                    date: new Date(current),
                    total_cost: subPool.total
                });
                current.setDate(current.getDate() + 1);
            }

            // decrement the total cost for each product (based on the product's start date) from the remaining sub pool
            totals.forEach((total, index) => {
                let cost = 0;
                let previous = totals[index - 1] ? totals[index - 1] : totals[0];
                let activeProducts = subPool.products.filter(product => _.isEqual(total.date, product.start_date));
                // decrement cost for each date
                cost = activeProducts.reduce((accumulator, product) => accumulator + product.total_cost, 0);
                total.total_cost = previous.total_cost - cost;
            });
        }

        setTotalCost(totals);
    }, [pool]);

    // useEffect(() => {
    //     console.log("total cost", totalCost);
    // }, [totalCost]);

    return (
        <Row>
            <Col>
                {totalCost.length ? <Chart
                    className={"fsa-dashboard-h-50"}
                    seriesColors={chartColors}
                >
                    <ChartTitle text={eA.year ? localization.toLanguageString(yearKey, mainMessages[siteLanguageDefault][yearKey]) + " " + eA.year
                        : localization.toLanguageString(yearKey, mainMessages[siteLanguageDefault][yearKey])}/>
                    <ChartTooltip render={totalCostTooltip}/>
                    <ChartLegend
                        position={"bottom"}
                        orientation={"horizontal"}
                    />
                    {/* total cost x-axis | months */}
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            name={"months"}
                            baseUnit={"days"}
                            type={"date"}
                            labels={{
                                ...AXIS_LABELS,
                                step: 31,
                                format: "MMM 'yy",
                                rotation: 0
                            }}
                        />
                    </ChartCategoryAxis>
                    {/* total cost y-axis | total cost */}
                    <ChartValueAxis>
                        <ChartValueAxisItem
                            labels={{format: "n", ...AXIS_LABELS}}
                            name={"currency"}
                        >
                            <ChartCategoryAxisTitle
                                text={currency}
                                font={'16px Graphik LG Web, serif'}
                            />
                        </ChartValueAxisItem>
                    </ChartValueAxis>
                    {/* product cost line series */}
                    <ChartSeries>
                        <ChartSeriesItem
                            name={localization.toLanguageString(actualUseKey, mainMessages[siteLanguageDefault][actualUseKey])}
                            type={"line"}
                            style={"step"}
                            data={totalCost}
                            field={"total_cost"}
                            categoryField={"date"}
                        />
                        {/*<ChartSeriesItem*/}
                        {/*    type={"linearTrendline"}*/}
                        {/*    name={localization.toLanguageString(predictedUseKey, mainMessages[siteLanguageDefault][predictedUseKey])}*/}
                        {/*    for={localization.toLanguageString(actualUseKey, mainMessages[siteLanguageDefault][actualUseKey])}*/}
                        {/*/>*/}
                    </ChartSeries>
                </Chart> : <NoDataOverlay style={{height: '50vh'}}/>}
            </Col>
        </Row>
    );
};

export default BudgetUtilizationChart;